// Query for Thid party links 

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a').forEach(link => {
    try {
      const isExternal =
        new URL(link.href).hostname !== window.location.hostname;

      if (isExternal) {
        link.setAttribute(
          'aria-label',
          `${link.textContent.trim()} - Redirecting to a third-party website (opens in a new tab).`
        );
      }
    } catch (e) {
      // Ignore invalid URLs
    }
  });


  let lastFocusedButton = null;
 
document.getElementById("cart-icon-bubble")?.addEventListener("click", function () {

  lastFocusedButton = this;
 
  setTimeout(function () {

    const drawerInner = document.querySelector(".drawer__inner");
 
    if (drawerInner) {

      drawerInner.setAttribute("tabindex", "-1");

      drawerInner.focus();

    }

  }, 1000);

});
 
document.querySelector(".drawer__close")?.addEventListener("click", function () {

  setTimeout(function () {

    if (lastFocusedButton) {

      lastFocusedButton.setAttribute("tabindex", "0");

      lastFocusedButton.focus();

    }

  }, 1000);

});
 
});
// Query for <br> tags
document.querySelectorAll('br').forEach(br => {
  br.setAttribute('aria-hidden', 'true');
});

// Query for email on Terms of Service page
setTimeout(() => {
  document.querySelectorAll('.aria-important').forEach(element => {
    element.setAttribute(
      'aria-label',
      'Send an email to michael@churnfoods.com'
    );
  });

  document.querySelectorAll('.aria-number').forEach(element => {
    element.setAttribute(
      'aria-label',
      'Call 310-570-5747'
    );
  });
}, 2000);
// Query fo add to bundle 
document.addEventListener('click', function (e) {
 
    if (e.target.closest('.bundle-add')) {
 
        const status = document.getElementById('bundle-status');
 
        status.textContent = '';
 
        setTimeout(() => {
            status.textContent = 'Product added to bundle.';
        }, 100);
    }
 
});
// Query  for Role figure to img 

setTimeout(() => {
  document.querySelectorAll('.role-figure').forEach(element => {
    element.setAttribute('role', 'img');
  });
}, 1000);


// Remove aria-label attribute from marquee 
const marqueeIds = [
  'AZWl6WU42NlRpNlZYN__layout_marquee_3PKTn3',
  'AYm5vRnpBcnlSMnFye__layout_marquee_mUBNtE'
];

const removeAriaLabels = () => {
  marqueeIds.forEach(id => {
    const container = document.getElementById(id);

    if (!container) return;

    container.querySelectorAll('a[aria-label]').forEach(link => {
      link.removeAttribute('aria-label');
    });
  });
};

removeAriaLabels();

new MutationObserver(removeAriaLabels).observe(document.body, {
  childList: true,
  subtree: true
});

// Remove role form summary to main
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details > summary[role="button"]').forEach(summary => {
    summary.removeAttribute('role');
  });
});